import { fetchAll } from '@/api/usertype'

const state = {
  all: [],
  isLoading: false
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const usertypes = await fetchAll()
      commit('setAll', usertypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
  },

  setAll (state, usertypes) {
    state.all = usertypes
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
